import { HeartPulse } from 'lucide-react';

interface EmptyStateProps {
  refetch: () => void;
}

export const EmptyState = ({ refetch }: EmptyStateProps) => (
  <div className="flex h-full flex-col items-center justify-center space-y-4 py-20 text-gray-500">
    <div className="rounded-full bg-gray-100 p-4">
      <HeartPulse className="h-16 w-16 text-gray-400" />
    </div>
    <div className="text-xl">No heart rate data available for today</div>
    <div className="max-w-md text-center text-sm text-gray-400">
      Your Oura Ring may not have synced today's data yet or there might not be enough data to
      display.
    </div>
    <button
      onClick={() => refetch()}
      className="mt-2 rounded-md bg-indigo-600 px-6 py-3 text-white transition-colors hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      Refresh Data
    </button>
  </div>
);
